// @flow
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LegacyLink from '../Common/LegacyLink';

const SideNavigation = () => {
  const isSpaceOwner = useSelector(state => state.auth?.user?.isSpaceOwner);
  const hasSeasonTickets = useSelector(
    state => state.auth?.user?.hasSeasonTicket
  );

  const baseClass = 'c-sideNavigation';

  // Change Bookings made to NavLink when no longer flagged
  return (
    <ul className={baseClass}>
      <li className={`${baseClass}__item`}>
        <NavLink
          activeClassName={`${baseClass}__link`}
          to="/dashboard/bookings/made"
        >
          Bookings made
        </NavLink>
      </li>

      {isSpaceOwner && (
        <li className={`${baseClass}__item`}>
          <LegacyLink to="dashboard/bookings/received">
            Bookings received
          </LegacyLink>
        </li>
      )}

      {hasSeasonTickets && (
        <li className={`${baseClass}__item`}>
          <LegacyLink to="dashboard/season-tickets">
            Tickets & permits
          </LegacyLink>
        </li>
      )}

      <li className={`${baseClass}__item`}>
        <LegacyLink to="dashboard/messaging">Messages</LegacyLink>
      </li>

      {isSpaceOwner && (
        <li className={`${baseClass}__item`}>
          <NavLink
            activeClassName={`${baseClass}__link`}
            to="/dashboard/parking-spaces"
          >
            Manage my spaces
          </NavLink>
        </li>
      )}

      <li className={`${baseClass}__item`}>
        <LegacyLink to="dashboard/billing/">Billing & withdrawals</LegacyLink>
      </li>

      <li className={`${baseClass}__item`}>
        <NavLink activeClassName={`${baseClass}__link`} to="/dashboard/profile">
          My profile
        </NavLink>
      </li>

      <li className={`${baseClass}__item`}>
        <NavLink activeClassName={`${baseClass}__link`} to="/refer-a-friend">
          Get free parking
        </NavLink>
      </li>

      <li className={`${baseClass}__item`}>
        <NavLink to="/auth/logout/">Log out</NavLink>
      </li>
    </ul>
  );
};

export default SideNavigation;
